/**
 * Кнопку для показа состава набора (products button) нужно показывать,
 * только если в биллинговой записи указан идетнификатор биллинговой таблицы.
 * @param {string} billingTableId
 * @returns {boolean}
 */
export function isProductsButtonVisible(billingTableId) {
  return billingTableId.length > 0;
}

export function mustHidePopover(interactedElem) {
  if(isProductsButton(interactedElem)) {
    return false;
  }

  if(isPopoverOrChild(interactedElem)) {
    return false;
  }

  return true;
}

function isProductsButton(elem) {
  if(elem === undefined || elem === null) {
    return false;
  }
  return elem.classList.contains('products-button');
}

function isPopoverOrChild(elem) {
  if(elem === undefined || elem === null) {
    return false;
  }

  const classList = elem.classList;
  if(classList !== undefined && classList.contains('popover')) {
    return true;
  }

  return isPopoverOrChild(elem.parentNode);
}
